import { Building2, MoonStar, Leaf, Castle } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";

export const Vision = () => {
  const { t } = useLanguage();

  const pillars = [
    { icon: Building2, label: t.vision_v1, testid: "vision-halal-hospitality" },
    { icon: MoonStar, label: t.vision_v2, testid: "vision-dzemat-prayer" },
    { icon: Leaf, label: t.vision_v3, testid: "vision-full-maintenance" },
    { icon: Castle, label: t.vision_v4, testid: "vision-expansion" },
  ];

  return (
    <section id="vision" data-testid="vision-section" className="relative py-28 sm:py-36 bg-[#070707] border-y border-[rgba(197,160,89,0.12)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <Eyebrow>{t.vision_eyebrow}</Eyebrow>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F3E5AB] leading-tight">{t.vision_title}</h2>
          <p className="mt-6 text-[#C7BFA7] font-light leading-relaxed text-base sm:text-lg">{t.vision_text}</p>

          <ul className="mt-10 space-y-4">
            {pillars.map((p, i) => (
              <Reveal key={p.testid} delay={0.1 + i * 0.08}>
                <li data-testid={p.testid} className="flex items-center gap-4 group">
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center border border-[rgba(197,160,89,0.4)] text-[#C5A059] group-hover:bg-[rgba(197,160,89,0.1)] transition-colors duration-500">
                    <p.icon size={17} strokeWidth={1.5} />
                  </span>
                  <span className="text-sm sm:text-base text-[#C7BFA7] tracking-wide">{p.label}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative">
            <div className="absolute -inset-3 border border-[rgba(197,160,89,0.25)] pointer-events-none" />
            <img
              src="/images/villa-aerial.png"
              alt="GoldenValley — vision du domaine"
              data-testid="vision-image"
              className="w-full h-[420px] sm:h-[520px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
